import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { TrendData } from '@/api/dashboardApi';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface TrendChartProps {
  data: TrendData;
  onPeriodChange: (period: 'WEEK' | 'MONTH' | 'QUARTER') => void;
  currentPeriod: 'WEEK' | 'MONTH' | 'QUARTER';
}

export const TrendChart: React.FC<TrendChartProps> = ({ 
  data, 
  onPeriodChange, 
  currentPeriod 
}) => {
  // 날짜 형식 변환 (yyyy-MM-dd -> MM/dd)
  const chartData = data.dataPoints.map(point => ({
    date: point.date.slice(5).replace('-', '/'), // "02-19" -> "02/19"
    웹사이트: point.websiteCrawling,
    'URL 입력': point.imageUrl,
    업로드: point.imageUpload,
    전체: point.total,
  }));

  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle>처리량 트렌드</CardTitle>
          <Tabs value={currentPeriod} onValueChange={(v) => onPeriodChange(v as any)}>
            <TabsList>
              <TabsTrigger value="WEEK">주간</TabsTrigger>
              <TabsTrigger value="MONTH">월간</TabsTrigger>
              <TabsTrigger value="QUARTER">분기</TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={350}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="웹사이트" 
              stroke="#3b82f6" 
              strokeWidth={2}
            />
            <Line 
              type="monotone" 
              dataKey="URL 입력" 
              stroke="#10b981" 
              strokeWidth={2}
            />
            <Line 
              type="monotone" 
              dataKey="업로드" 
              stroke="#f59e0b" 
              strokeWidth={2}
            />
            <Line 
              type="monotone" 
              dataKey="전체" 
              stroke="#8b5cf6" 
              strokeWidth={2}
              strokeDasharray="5 5"
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
